var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 299,
    height: 299,
    viewBox: "0 0 299 299",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M286.542 214.121V270.433C286.542 279.216 275.927 283.614 269.723 277.397L251.135 258.809C223.727 284.249 187.56 298.988 149.5 298.988C75.5723 299 11.9601 243.897 1.50756 170.829C0.0499334 160.613 7.15118 151.145 17.367 149.687C27.4832 148.217 37.0387 155.33 38.5088 165.546C46.3326 220.313 94.0481 261.625 149.488 261.625C177.569 261.625 204.304 250.961 224.748 232.448L208.453 216.152C202.249 209.948 206.646 199.333 215.417 199.333H271.729C279.902 199.333 286.517 205.949 286.517 214.121H286.542ZM297.493 128.171C287.04 55.1032 223.428 0 149.5 0C111.44 0 75.2734 14.7382 47.865 40.1781L29.2896 21.6027C23.0854 15.3985 12.4709 19.7963 12.4709 28.567V84.8786C12.4709 93.0513 19.0863 99.6667 27.2589 99.6667H83.5581C92.3413 99.6667 96.7391 89.0522 90.5224 82.8479L74.2393 66.5524C94.671 48.0393 121.419 37.375 149.5 37.375C204.94 37.375 252.655 78.6744 260.479 133.454C261.812 142.772 269.81 149.5 278.955 149.5C279.827 149.5 280.736 149.438 281.621 149.313C291.837 147.855 298.963 138.387 297.493 128.171Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.b4971ddfa159a34d51ed0c02a9a47de6.svg";
export { ForwardRef as ReactComponent };